<template>
  <button @click="handleClick" class="button" :class="type">
    <slot></slot>
  </button>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  name: "Button",
  props: {
    type: {
      type: String,
      default: "filled",
    },
  },
  data() {
    return {};
  },
  mounted: function () {
    // console.log(this.type);
  },
  methods: {
    handleClick: function (event) {
      this.$emit("click", event);
    },
  },
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
// https://stackoverflow.com/questions/52707458/binding-scss-variables-with-an-attached-prop-in-vue-js
.button {
  cursor: pointer;
  // @include card-shadow()

  &.image {
    padding: 0;
    border: 0;
    width: 40px;
    background: none;

    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  &.outline {
    padding: 6px 14px;
    color: $dark-green;
    background-color: white;
    border: 1px solid $dark-green;
    border-radius: $border-radius;

    &:hover {
      color: $green-4;
      border-color: $green-4;
    }
  }

  &.filled {
    width: 46%;
    padding: 6px 14px;
    color: white;
    background-color: $dark-green;
    border: 1px solid transparent;
    border-radius: $border-radius;

    &:hover,
    &.active {
      background-color: $green-4;
    }
  }

  &.round {
    // background-color: ;
    width: 40px;
    height: 40px;
    background: $dark-green url("../../assets/img/arrow.png") no-repeat 55% 50%;
    background-size: 30%;
    border: 1px solid transparent;
    border-radius: 50%;

    &:hover {
      background-color: $green-4;
    }
  }
}
</style>
